<template>
  <div>
    <div v-if="message.showMessage || message.showPhotoContent">
      <div
        v-if="message.isActionMessage"
        class="text-center fw-semibold font-size-12 my-1">
        <div
          class="px-3 py-2"
          style="display: inline-block; background-color: #f1f4f8; border-radius: 999px"
          v-bind:style="message.id.uidFrom !== '0' ? 'margin-right: -100px;' : 'margin-left: -100px'">
          {{ getActionMessage }}
          <span
            v-if="message.msgType === 'chat.todo' && ['todo.ding', 'todo.update'].includes(JSON.parse(message.content).action)"
            @click="openTodo(message, JSON.parse(JSON.parse(message.content).params).item)"
            class="text-blue me-2 pointer">
            xem chi tiết
          </span>
        </div>
      </div>
      <div
        v-else
        class="ctext-wrap-content message-content">
        <div v-bind:style="message.checkUndoMessage ? 'background-color: #eaedf0 !important;padding:10px;opacity:0.7' : ''">
          <div
            class="font-size-12"
            style="display: block; padding: 0 0 2px 3px; color: #8e969f; font-weight: 550"
            v-if="isGroup && !message.isActionMessage && message.id.uidFrom != '0'">
            {{ getName }}
          </div>

          <div
            class="rounded-1 p-2"
            v-if="message.quoteMsg && messageRepied == undefined"
            style="background-color: #eaedf0 !important">
            <div
              v-if="
                JSON.parse(message.quoteMsg).cliMsgType !== 32 &&
                JSON.parse(message.quoteMsg).cliMsgType !== 37 &&
                JSON.parse(message.quoteMsg).cliMsgType !== 49
              "
              class="fw-semibold font-size-14 my-1">
              {{ JSON.parse(message.quoteMsg).fromD }}
            </div>

            <ChatText
              :mentions="mentionsQuote"
              v-if="JSON.parse(message.quoteMsg).cliMsgType == 1"
              :content="JSON.parse(message.quoteMsg).msg" />

            <ChatFile
              v-if="JSON.parse(message.quoteMsg).cliMsgType == 46"
              :href="JSON.parse(JSON.parse(message.quoteMsg).attach).href"
              :thumb="JSON.parse(JSON.parse(message.quoteMsg).attach).thumb"
              :title="JSON.parse(JSON.parse(message.quoteMsg).attach).title"
              :file-size="JSON.parse(JSON.parse(JSON.parse(message.quoteMsg).attach).params).fileSize"
              :fileExt="JSON.parse(JSON.parse(JSON.parse(message.quoteMsg).attach).params).fileExt"
              :account-id="accountId" />

            <div
              v-if="
                JSON.parse(message.quoteMsg).cliMsgType == 32 || JSON.parse(message.quoteMsg).cliMsgType == 37 || JSON.parse(message.quoteMsg).cliMsgType == 49
              "
              class="d-flex">
              <ChatPhoto
                :href="JSON.parse(JSON.parse(message.quoteMsg).attach).href"
                :quote="true" />
              <div class="mx-2">
                <div class="fw-semibold font-size-14">{{ JSON.parse(message.quoteMsg).fromD }}</div>
                <div>[Hình ảnh]</div>
              </div>
            </div>

            <ChatRecommended
              v-if="JSON.parse(message.quoteMsg).cliMsgType == 38"
              :title="JSON.parse(JSON.parse(message.quoteMsg).attach).title"
              :thumb="JSON.parse(JSON.parse(message.quoteMsg).attach).thumb"
              :phone="getPhone()"
              :qrCodeUrl="getQrCode()" />

            <ChatLocation
              v-if="JSON.parse(message.quoteMsg).cliMsgType == 43"
              :description="JSON.parse(JSON.parse(message.quoteMsg).attach).desc"
              :latitude="JSON.parse(JSON.parse(message.quoteMsg).attach).lat"
              :longitude="JSON.parse(JSON.parse(message.quoteMsg).attach).lo" />

            <ChatVideo
              v-if="JSON.parse(message.quoteMsg).cliMsgType == 44"
              :href="JSON.parse(JSON.parse(message.quoteMsg).attach).href"
              :thumb="JSON.parse(JSON.parse(message.quoteMsg).attach).thumbUrl" />

            <ChatVoice
              :src="JSON.parse(JSON.parse(message.quoteMsg).attach).href"
              v-if="JSON.parse(message.quoteMsg).cliMsgType == 31" />

            <ChatSticker
              v-if="JSON.parse(message.quoteMsg).cliMsgType == 36"
              :id="JSON.parse(JSON.parse(message.quoteMsg).attach).id" />
          </div>
          <div v-if="message.msgType === 'LOADING_FILE'">
            <FileLoading :file="message" />
          </div>
          <div v-if="message.msgType == 'webchat'">
            <span v-if="message.quoteMsg && messageRepied == undefined">Trả lời :</span>
            <ChatText
              :mentions="message.mentions"
              :messageRepied="messageRepied"
              :content="message.content" />
          </div>
          <ChatTodo
            :account-id="accountId"
            :members="members"
            v-if="message.msgType === 'chat.todo' && JSON.parse(message.content).action === 'todo.create'"
            :message="message" />
          <ChatPoll
            v-if="message.msgType == 'group.poll'"
            :conversationId="conversationId"
            :account-id="accountId"
            :content="JSON.parse(message.content)" />

          <ChatPhoto
            :messageRepied="messageRepied"
            v-if="message.showPhotoContent"
            :message="message"
            :message-list="messageList"
            :href="getCloudUrl(JSON.parse(message.content).href, message)"
            :title="JSON.parse(message.content).title"
            :group-layout-id="message.groupLayoutId" />

          <ChatSticker
            :messageRepied="messageRepied"
            v-if="message.msgType == 'chat.sticker'"
            :id="JSON.parse(message.content).id" />

          <ChatGif
            :message-id="message.id"
            :account-id="accountId"
            :messageRepied="messageRepied"
            :href="getCloudUrl(JSON.parse(message.content).href, message)"
            :thumb="JSON.parse(message.content).thumb"
            title=""
            v-if="message.msgType == 'chat.gif'">
            {{ JSON.parse(message.content).href }}
          </ChatGif>
          <ChatPhoto
            :messageRepied="messageRepied"
            :href="JSON.parse(message.content).href"
            title=""
            v-if="message.msgType == 'chat.doodle'" />

          <ChatECard
            v-if="message.msgType == 'chat.ecard'"
            :href="JSON.parse(message.content).href"
            :title="JSON.parse(message.content).title"
            :description="JSON.parse(message.content).description" />

          <ChatVideo
            :messageRepied="messageRepied"
            v-if="message.msgType == 'chat.video.msg'"
            :href="getCloudUrl(JSON.parse(message.content).href, message)"
            :thumb="JSON.parse(message.content).thumb" />

          <ChatLocation
            :messageRepied="messageRepied"
            :description="JSON.parse(this.message.content).description"
            v-if="message.msgType == 'chat.location.new'"
            :latitude="JSON.parse(JSON.parse(this.message.content).params).latitude"
            :longitude="JSON.parse(JSON.parse(this.message.content).params).longitude" />

          <ChatFile
            :messageRepied="messageRepied"
            :thumb="JSON.parse(message.content).thumb"
            :file-ext="JSON.parse(JSON.parse(message.content).params).fileExt"
            :title="JSON.parse(message.content).title"
            :file-size="JSON.parse(JSON.parse(message.content).params).fileSize"
            :href="getCloudUrl(JSON.parse(message.content).href, message)"
            v-if="message.msgType == 'share.file'"
            :account-id="accountId"
            :message-id="message.id" />

          <ChatVoice
            :messageRepied="messageRepied"
            v-if="message.msgType == 'chat.voice'"
            :src="JSON.parse(JSON.parse(this.message.content).params).m4a" />

          <div v-if="message.msgType == 'chat.recommended'">
            <ChatCall
              :messageRepied="messageRepied"
              v-if="JSON.parse(message.content).action == 'recommened.calltime'"
              :duration="JSON.parse(JSON.parse(message.content).params).duration" />
            <chat-recommended
              :messageRepied="messageRepied"
              v-if="JSON.parse(message.content).action == 'recommened.use'"
              :thumb="JSON.parse(message.content).thumb"
              :title="JSON.parse(message.content).title"
              :phone="JSON.parse(JSON.parse(message.content).description).phone"
              :qrCodeUrl="JSON.parse(JSON.parse(message.content).description).qrCodeUrl" />
            <chat-business-card
              v-if="JSON.parse(message.content).action == 'recommened.user'"
              :message="message"
              :account-id="accountId"
              :messageRepied="messageRepied" />

            <div v-if="JSON.parse(message.content).action == 'recommened.link'">
              <ChatText
                v-if="messageRepied"
                :mentions="message.mentions"
                :messageRepied="messageRepied"
                :content="JSON.parse(message.content).title" />
              <div v-else>
                <ChatText
                  :mentions="message.mentions"
                  v-if="JSON.parse(message.content).title != ''"
                  :content="JSON.parse(message.content).title" />
                <div v-bind:class="[ERROR_LINK, ''].includes(thumbContent) ? 'd-flex' : ''">
                  <el-image
                    class="mt-2 rounded-1"
                    v-if="thumbContent !== null && thumbContent !== undefined"
                    :src="thumbContent === '' ? ERROR_LINK : thumbContent"
                    fit="cover"
                    v-bind:style="[ERROR_LINK, ''].includes(thumbContent) ? 'height:70px;width:70px;margin:10px 10px 10px 0px' : ''"></el-image>
                  <div v-bind:class="[ERROR_LINK, ''].includes(thumbContent) ? 'd-flex flex-column mt-2' : ''">
                    <div v-if="JSON.parse(message.content).params && JSON.parse(JSON.parse(message.content).params).mediaTitle">
                      <ChatText
                        :mentions="message.mentions"
                        :content="JSON.parse(JSON.parse(message.content).params).mediaTitle"
                        class="fw-semibold" />
                    </div>
                    <div
                      v-if="JSON.parse(message.content).description && ![ERROR_LINK, ''].includes(thumbContent)"
                      style="color: #7589a3">
                      {{ JSON.parse(message.content).description }}
                    </div>
                    <a
                      :href="JSON.parse(JSON.parse(message.content).params).src"
                      class="text-decoration-none font-size-12 mt-3 fw-semibold">
                      {{ JSON.parse(JSON.parse(message.content).params).src }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="JSON.parse(message.content).action == 'recommened.misscall'">
              <div class="text-error">Cuộc gọi nhỡ</div>

              <div v-if="JSON.parse(message.content).action == 'recommened.link'">
                <ChatText
                  :mentions="message.mentions"
                  :content="JSON.parse(message.content).title" />
              </div>
            </div>
          </div>

          <div
            v-if="message.checkUndoMessage"
            class="text-danger">
            <span
              class="mb-0"
              v-if="message.checkDeleteMessage">
              Tin nhắn đã được xóa
            </span>
            <span
              class="mb-0"
              v-else>
              Tin nhắn đã được thu hồi
            </span>
          </div>
          <p
            v-if="!messageRepied"
            class="chat-time mb-0"
            style="color: #959596 !important">
            <span
              v-if="message.replaceUrl"
              class="text-primary mx-1">
              <el-tooltip
                effect="dark"
                content="Đã đồng bộ Salework Cloud"
                placement="top">
                <img
                  src="/assets/icon/ic_cloud.svg"
                  style="height: 24px; width: 24px; color: #0a58c0" />
              </el-tooltip>
            </span>
            <span class="align-middle">{{ formatLastMessageTime(message.ts) }}</span>
            <span
              class="align-middle"
              v-if="message.sendBy">
              - Người gửi: {{ message.sendBy }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatText from "./ChatText";
import ChatPhoto from "./ChatPhoto";
import ChatSticker from "./ChatSticker";
import ChatECard from "./ChatECard";
import ChatLocation from "./ChatLocation";
import ChatFile from "./ChatFile";
import ChatVoice from "./ChatVoice";
import ChatRecommended from "./ChatRecommended";
import ChatVideo from "./ChatVideo";
import ChatCall from "./ChatCall";
import ChatPoll from "./ChatPoll";
import ChatBusinessCard from "./ChatBusinessCard";
import FileLoading from "./FileLoading";
import ChatTodo from "./ChatTodo";
import ChatGif from "@/components/message/ChatGif";

export default {
  name: "MessageContent",
  components: {
    ChatGif,
    ChatTodo,
    FileLoading,
    ChatBusinessCard,
    ChatPoll,
    ChatCall,
    ChatVideo,
    ChatRecommended,
    ChatVoice,
    ChatFile,
    ChatLocation,
    ChatECard,
    ChatSticker,
    ChatPhoto,
    ChatText,
  },
  props: ["message", "messageList", "isGroup", "conversationId", "accountId", "messageRepied", "sendByList", "members", "replaceUrl"],
  data() {
    return {
      groupLayoutId: null,
      ERROR_LINK:
        "https://photo-link-talk.zadn.vn/photolinkv2/720/aHR0cHM6Ly9yZXMtemFsby56YWRuLnZuL3VwbG9hZC9tZWRpYS8yMDE5LzEwLzE1L2ZlZWRfdGh1bWJfbGlua19fMV9fMTU3MTEzMzEyMjc3OF85Mzc4MC5wbmc=",
    };
  },

  computed: {
    getNameTodo() {
      let params = JSON.parse(JSON.parse(this.message.content).params);
      if (params.item.extra.isGroup) {
        let item = this.members.find((s) => s.id === params.editor);
        if (item) {
          return item.name;
        }
        return "";
      } else {
        if (this.accountId === params.editor) {
          return this.app.accounts.find((s) => s.accountId === this.accountId).displayName;
        }
        return this.app.selectedConversation.toName;
      }
    },
    getActionMessage() {
      let action = JSON.parse(this.message.content).action;
      if (["todo.update", "todo.ding", "todo.delete"].includes(action)) {
        return "" + this.getNameTodo + this.getContentAction(this.message.content, this.accountId) + "";

        // return this.getTitleTodoName(this.message);
        // return this.getNameTodo() + this.getContentAction(this.message.content, this.accountId);
      } else if ("todo.ding_ack" === action) {
        return "Người dùng đã nhận nhắc nhở từ bạn : " + JSON.parse(JSON.parse(this.message.content).params).item.description;
      } else {
        return JSON.parse(this.message.content).title;
      }
    },

    getName() {
      let id = this.message.id.uidFrom != "0" ? this.message.id.uidFrom : this.conversationId.accountId;
      try {
        return this.members.find((m) => m.id == id).name;
      } catch (e) {
        return "";
      }
    },
    thumbContent() {
      return JSON.parse(this.message.content).thumb;
    },
    mentionsQuote() {
      try {
        let item = JSON.stringify(JSON.parse(JSON.parse(this.message.quoteMsg).attach).mentions);
        return item;
      } catch (e) {
        return "";
      }
    },
  },
  methods: {
    getPhone() {
      try {
        return JSON.parse(JSON.parse(this.message.content).description).phone;
      } catch (e) {
        return null;
      }
    },
    getQrCode() {
      try {
        JSON.parse(JSON.parse(JSON.parse(this.message.quoteMsg).attach).description).qrCodeUrl;
      } catch (e) {
        return null;
      }
    },
    // showPhoto() {
    //   console.log("showPhoto");
    //   if (this.message.msgType == "chat.photo") {
    //     try {
    //       if (JSON.parse(this.message.content).params) {
    //         let params = JSON.parse(JSON.parse(this.message.content).params);
    //         if (params.is_group_layout) {
    //           this.groupLayoutId = params.group_layout_id;
    //           if (params.id_in_group === 0) {
    //             return true;
    //           } else {
    //             let id = JSON.parse(JSON.parse(this.message.content).params).group_layout_id;
    //             let id_in_group = JSON.parse(JSON.parse(this.message.content).params).id_in_group;
    //
    //             let idsInGroup = this.messageList.filter(c => {
    //               if (c.msgType === "chat.photo") {
    //                 let params = JSON.parse(JSON.parse(c.content).params);
    //                 if (params.group_layout_id) {
    //                   return params.group_layout_id === id;
    //                 }
    //               }
    //               return false;
    //             }).map(s => JSON.parse(JSON.parse(s.content).params).id_in_group);
    //             if (id_in_group === Math.min(...idsInGroup)) {
    //               return true;
    //             } else {
    //               return false;
    //             }
    //           }
    //         } else return true;
    //       }
    //     } catch (e) {
    //       console.log(e);
    //     }
    //     return true;
    //   }
    //   return false;
    // },

    getPlayerOptions() {
      let content = JSON.parse(this.message.content);
      return {
        muted: true,
        controls: true,
        sources: [
          {
            type: "video/mp4",
            src: content.href,
          },
        ],
        poster: content.thumb,
        height: 400,
        width: 400,
      };
    },
  },
};
</script>

<style scoped>
</style>
